/* Component Dependencies */
var activateOnlineAccountTemplate = require('templates/activateOnlineAccount.hbs');
var AriesComponent = require('libs/aries-component');
var passwordValidation = require('utils/passwordValidation.js');
var emailValidationHandler = require('utils/emailValidation.js');
var sendOtpAjax = require('utils/sendOtpAjax.js');
AriesComponent.create({
  type: 'activateOnlineAccount',

  template: {
    'activateOnlineAccount': activateOnlineAccountTemplate
  },
  events: {
    'click .js-btn-submit': 'validationEmail'
  },
  bindEvents: function () {
    var _self = this;
    var passwordValidationOptions = {
      isLabelIcon: false,
      passwordModuleSelector: '.js-password-info',
      passwordIconSelector: '.js-field-password + .t-icon',
      confirmPasswordIconSelector: '.js-field-password-confirmation + .t-icon',
      errorClasses: 't-icon-cross',
      successClasses: 't-icon-check'
    };
    passwordValidation.initialize(this.$el, passwordValidationOptions);
    
    // If country code not 86 on submit, hiding the otp related fields and enabling the dropdown and mobile no field
      if(($('#mobile-telephone').text().replace(/\+/g, "")) != "86"){
        var otpFields = $('.js-otp-sent-message, #containerDivSendVerificationBtn, #containerDivOtpAndResendLink');
        var mobileOptionalLabel = $('.js-mobile-optional-label');
        var emailOptionalLabel = $('.js-email-optional-label');
        otpFields.hide();
							$('.before-otp-sent, .after-otp-sent').removeClass('l-display-inline').addClass('is-hidden');
        $('#mobile-phone').removeClass("t-bg-standard-30").prop("disabled", false);
        $('#div-custom-arrow-dropdown-button').removeClass('t-bg-standard-30').addClass('checkMobile');
        mobileOptionalLabel.removeClass('is-hidden');
        emailOptionalLabel.addClass('is-hidden');
      }

    //RHS after submit based on errors in any filed, Enable the below fields & the dropdown and mobile no field
      if ($('#verification-code').hasClass("is-error")|| $('#field-email').hasClass("is-error")|| $('#field-password').hasClass("is-error")|| $('#field-password-confirmation').hasClass("is-error")||$('.js-email span.t-icon-cross').hasClass('t-icon-cross')){
        var submitErrorFieldEnable = $('#field-email, #field-password, #field-password-confirmation, #field-remember-me, .js-field-one-time-code');
        submitErrorFieldEnable.removeClass("is-disabled t-cursor-default t-bg-standard-30").prop("disabled", false);
        $('.js-btn-submit').removeClass("t-bg-standard-100 t-border").prop("disabled", false);
        $('.js-resend-code').removeClass("l-resend-code");
        $('#send-verification-code-btn').addClass("t-bg-standard-100 t-border").prop("disabled", true);
        if($('#containerDivSendVerificationBtn').is(":visible")){
          $('#mobile-phone').removeClass("t-bg-standard-30").prop("disabled", false);
          $('#div-custom-arrow-dropdown-button').removeClass('t-bg-standard-30').addClass('checkMobile');
        }  
      }

    //If mobileauthverification is true then perform the send verfication code and resend otp click events to trigger ajax
      if ($('.js-send-otp').length) {
        var countryPhoneCode = $(".custom-arrow-mobile #mobile-telephone").text();
        $('#countryPhonePrefix').attr("value", countryPhoneCode);
        $(_self.$el.find('.checkMobile')).on('click', _self.countryWithCodeMobilePhoneDropdown.bind(_self));
        $(_self.$el.find('.js-send-verification-code-btn, .js-resend-code')).on('click', _self.sendOtpCodeHandler.bind(_self));
        //Enable and Disable send verification button
        $(_self.$el.find('#mobile-phone')).on('input change', _self.enableSendVerificationBtn.bind(_self));
      }

      //Added error class if the email field has cross icon
      if($('.js-email span.t-icon-cross').hasClass('t-icon-cross')){
        $('#field-email').addClass('is-error');
      }

      //If sendverification button is available then showing the before and  hiding after OTP messaging
      if($('#containerDivSendVerificationBtn').is(":visible")){
        $('.before-otp-sent').addClass('l-display-inline').removeClass('is-hidden');
        $('.after-otp-sent').removeClass('l-display-inline').addClass('is-hidden');
      }
      
      //If country code 86 and mobile field empty showing the before and  hiding after OTP messaging
      if(($('#mobile-telephone').text().replace(/\+/g, "")) == "86"){
        var isEmptyMobile = $('#mobile-phone').val();
          if (isEmptyMobile == "") {
            $('.before-otp-sent').addClass('l-display-inline').removeClass('is-hidden');
            $('.after-otp-sent').removeClass('l-display-inline').addClass('is-hidden'); 
          }
      }
  },

  countryWithCodeMobilePhoneDropdown: function countryWithCodeMobilePhoneDropdown() {
    var _self = this;
    $(".custom-arrow-mobile").find("b").toggleClass('t-icon-arrow-up t-icon-arrow-down');
    $(".mobilePhoneDropdownList").slideToggle();
    $(".custom-arrow-mobile").css("border-color", "lightgray");
    $(".custom-arrow-mobile").toggleClass('borderMob');
    $(".mobilePhoneDropdownList").on("click", "li", function () {

      var selectedValue = $(this).attr('data-value');
      var splitValue = selectedValue.split(' ');
      var countryPhoneCode = $(this).attr("value");

      if (splitValue.length === 2) {
        $(".custom-arrow-mobile #mobile-telephone").text(splitValue[0]);
        $("#mobilePhoneDropdownList").val(countryPhoneCode);
        $("#countryPhonePrefix").val(splitValue[0]);
        $(".custom-arrow-mobile b").removeClass("t-icon-arrow-up").addClass("t-icon-arrow-down");
        if ($('.js-send-otp').length) {
          _self.toggleOtpFields();
        }
      }
      $('#field-country-prefix-code').hide();
      $(".custom-arrow-mobile").css("border-color", "lightgray");
    });
  },

  validationEmail: function _validationEmail(e) {
    if (!emailValidationHandler.emailValidation($('#field-email').val(), 'email')) {
      $('#email-validation').removeClass('l-display-none');
      if ($('.tile-message-box')) {
        $('.tile-message-box').addClass('l-display-none');
      }
      e.preventDefault();
    } else {
      $('#email-validation').addClass('l-display-none');
    }
  },


  /**
   * This function is used to trigger ajax call for generating new OTP
   * sendOtpCodeHandler
   * @params  {event}
   */
  sendOtpCodeHandler: function _sendOtpCodeHandler(event) {
    event.preventDefault();
    var _self = this;
    var ajaxurl = $('.js-send-otp').data('ajaxurl');
    //Setting data for ajax call to trigger
    var data = {};
    data.context = _self.getContextData();
    data.context.mobilePhone = ($('#mobile-telephone').text().replace(/\+/g, "")) + $('#mobile-phone').val();
    data.context.otpRequest = true;
    data.context.activateOnlineRequest = true;
    //accountAssociation is true if the send verfication code button is clicked and false if resedn code link is clicked
    data.context.accountAssociation = (event.target.tagName != "A") ? true : false;
    //Trigger Ajax call
    sendOtpAjax.triggerAjaxCall(_self, ajaxurl, data);
  },

  /**
   * This function is used to Enable and disable the send-verfication-btn on change of mobile phone field
   * enableSendVerificationBtn
   * @params  {event}
   */
  enableSendVerificationBtn: function _enableSendVerificationBtn(event) {
    var isEmpty = $('#mobile-phone').val(),
      _self = this;

    //On changing mobile number field performing the below actions
        if (($('#mobile-telephone').text().replace(/\+/g, "")) == "86") {
          $('#field-email, #field-password, #field-password-confirmation, #field-remember-me, .js-field-one-time-code').addClass("is-disabled t-cursor-default t-bg-standard-30").prop("disabled", true);
          $('#verification-code, #field-password, #field-password-confirmation').val('');
          $('#verification-code, #field-email, #field-password, #field-password-confirmation').removeClass('is-error');
          $('span.t-icon.t-icon-right.t-icon-cross').removeClass("t-icon-cross"); 
          $('span.t-icon.t-icon-right.t-icon-check').removeClass("t-icon-check");
          $('.js-btn-submit').addClass("t-bg-standard-100 t-border").prop("disabled", true);
          $('.js-resend-code').addClass("l-resend-code");
          $('.before-otp-sent').addClass('l-display-inline').removeClass('is-hidden');
          $('.after-otp-sent').removeClass('l-display-inline').addClass('is-hidden');
        }
    //If mobile no filed not empty enable the send verifcation button otherwise disabling
        if (isEmpty != "") {
          $('.js-send-verification-code-btn').removeClass("is-disabled t-cursor-default t-bg-standard-100 t-border").prop("disabled", false);
        } 
        else {
          $('.js-send-verification-code-btn').addClass("t-bg-standard-100 t-border").prop("disabled", true);
          $('.js-resend-code.js-send-verification-code-btn').removeClass("t-bg-standard-100 t-border").prop("disabled", true);
        }
  },
  /**
   * This function is used toggle otpSentMessage, otp field and send verifcation code on change of countryPrefixDropdown
   * toggleOtpFields
   * @params  {event}
   */
  toggleOtpFields: function _toggleOtpFields() {
    var _self = this;
    var otpFields = $('#containerDivSendVerificationBtn, #containerDivOtpAndResendLink');
    var mobileOptionalLabel = $('.js-mobile-optional-label');
    var emailOptionalLabel = $('.js-email-optional-label');
    //if countryPrefixCode is China(CN-86) then show the otp fields, if countryPrefixCode is other(like +1, +36) then hide these fields
    if (($('#mobile-telephone').text().replace(/\+/g, "")) == "86") {
        otpFields.show();
        mobileOptionalLabel.addClass('is-hidden');
        emailOptionalLabel.removeClass('is-hidden');
								$('.before-otp-sent').addClass('l-display-inline').removeClass('is-hidden');
        $('.after-otp-sent').removeClass('l-display-inline').addClass('is-hidden');
        $('#verification-code, #field-password, #field-password-confirmation').val('');
        $('#verification-code, #field-email, #field-password, #field-password-confirmation').removeClass('is-error');
        $('span.t-icon.t-icon-right.t-icon-cross').removeClass("t-icon-cross"); 
        $('span.t-icon.t-icon-right.t-icon-check').removeClass("t-icon-check");
        if ($('#send-verification-code-btn').hasClass("is-disabled")) {
            $('#field-email, #field-password, #field-password-confirmation, #field-remember-me, .js-field-one-time-code').removeClass("is-disabled t-cursor-default t-bg-standard-30").prop("disabled", false);
            $('.js-btn-submit').removeClass("t-bg-standard-100 t-border").prop("disabled", false);
            $('.js-resend-code').removeClass("l-resend-code");
          } 
        else {
            $('#field-email, #field-password, #field-password-confirmation, #field-remember-me, .js-field-one-time-code').addClass("is-disabled t-cursor-default t-bg-standard-30").prop("disabled", true);
            $('.js-btn-submit').addClass("t-bg-standard-100 t-border").prop("disabled", true);
            $('.js-resend-code').addClass("l-resend-code");
          }
    } 
    else {
      otpFields.hide();
      mobileOptionalLabel.removeClass('is-hidden');
      emailOptionalLabel.addClass('is-hidden');
					 $('.before-otp-sent, .after-otp-sent').removeClass('l-display-inline').addClass('is-hidden');
      $('span.t-icon.t-icon-right.t-icon-cross').addClass("t-icon-cross"); 
      $('span.t-icon.t-icon-right.t-icon-check').addClass("t-icon-check");
      $('#field-email, #field-password, #field-password-confirmation, #field-remember-me').removeClass("is-disabled t-cursor-default t-bg-standard-30").prop("disabled", false);
      $('.js-btn-submit').removeClass("t-bg-standard-100 t-border").prop("disabled", false);
      $('.js-resend-code').addClass("l-resend-code");
    }
  }

});
